<template>
  <ModalComponent
    :name="fileName"
    :adaptive="true"
    :height="500"
    :shift-y="0.1"
    @opened="initFile"
  >
    <ModalContainer
      title="Attachments"
      @close="$modal.hide(fileName)"
    >
      <template #top-left>
        <div class="flex items-center space-x-2">
          <div class="max-w-[300px] overflow-hidden text-ellipsis text-base">
            {{ printFileName }}
          </div>
          <div class="text-lg">
            |
          </div>
          <div>
            <BaseButton
              variant="secondary"
              title="Download"
              @click="onDownload"
            >
              Download
            </BaseButton>
          </div>
        </div>
      </template>
      <div v-if="loading">
        <PreloaderIcon class="mx-auto text-zuno-turquoise opacity-100" />
      </div>
      <div v-else>
        <embed
          v-if="fileExtension === 'pdf'"
          :src="`${base64File}#toolbar=0&@view=FitH`"
          class="w-full"
          style="width: 100%; height: 40rem"
          :style="maxHeightStyle"
        >
        <div
          v-else
          style="width: 100%; max-height: 40rem"
        >
          <img
            :src="base64File"
            :style="maxHeightStyle"
            class="w-full object-contain"
          >
        </div>
      </div>
    </ModalContainer>
  </ModalComponent>
</template>

<script>
export default {
  name: 'AttachmentViewer',

  props: {
    fileName: {
      type: String,
      default: 'Filename',
    },
  },

  data() {
    return {
      loading: true,
      base64File: null,
      blobFile: null,
    }
  },

  computed: {
    printFileName() {
      const filenameArr = this.fileName.split('-')
      return filenameArr[filenameArr.length - 1]
    },
    fileExtension() {
      return this.fileName.split('.').pop()
    },
    mimeType() {
      const mimeTypesMap = {
        xls: 'application/vnd.ms-excel',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        csv: 'text/csv',
        pdf: 'application/pdf',
        png: 'image/png',
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        bmp: 'image/bmp',
      }
      return mimeTypesMap[this.fileExtension] || 'application/octet-stream'
    },
    isViewable() {
      if (this.mimeType === 'application/pdf') return true
      return this.mimeType.startsWith('image/')
    },
    maxHeightStyle() {
      return `max-height: ${window.innerHeight - 200}px;`
    },
  },

  methods: {
    async initFile() {
      this.loading = true

      await this.fetchFile()

      if (!this.isViewable) {
        this.onDownload()
        this.$modal.hide(this.fileName)
      }

      this.loading = false
    },
    async blobToBase64() {
      const res = await new Promise((resolve) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.readAsDataURL(this.blobFile)
      })
      return res
    },
    async fetchFile() {
      const cid = localStorage.getItem('cid')

      await this.$apis.esgMetrics
        .downloadDocument(cid, this.fileName, { type: 'ghg' })
        .then(async ({ data }) => {
          this.blobFile = new Blob([data], { type: this.mimeType })
          this.base64File = await this.blobToBase64()
        })
    },

    onDownload() {
      const link = window.URL.createObjectURL(this.blobFile)
      const a = document.createElement('a')
      a.href = link
      a.download = this.fileName
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(link)
    },
  },
}
</script>
